<form [formGroup]="form" class="relative p-1px">
  <div class="text-center italic mb-36px mt-8px md:mt-16px">
    <div class="text-secondary">
      Thank you <span class="capitalize">{{ formS.userName }}</span> for
      providing your contact details.
    </div>
    <div class="mt-16px">
      Please provide
      <span *ngIf="formS.accountType === USER_TYPE.PERSONAL"
        >your Personal Public Service [PPS] number</span
      ><span *ngIf="formS.accountType === USER_TYPE.COMPANY"
        >VAT number of your company</span
      >
      and upload a supporting document below, in order to create the account and
      rest assured that these will not be shared and will be kept confidential,
      as per our
      <a
        class="ib-link ib-link-secondary"
        target="_blank"
        href="https://www.investabill.com/privacy/"
        >Privacy Policy</a
      >.
    </div>
  </div>

  <ib-mat-form-field-wrap
    *ngIf="formS.accountType === USER_TYPE.PERSONAL"
    [formCtrlName]="SIGN_UP_FIELDS.PERSON_PPS"
    [formCtrl]="form.get(SIGN_UP_FIELDS.PERSON_PPS)"
    [showClearBtn]="true"
    [tooltipText]="
      'A person should enter their Personal Public Service [PPS] number that is 7 numbers followed by either one or two letters.'
    "
  >
    <mat-form-field>
      <mat-label>Personal Public Service [PPS]</mat-label>
      <input
        matInput
        #ppsInput
        formControlName="{{ SIGN_UP_FIELDS.PERSON_PPS }}"
        type="text"
        (keydown.enter)="submitFromInput($event)"
        required
      />
    </mat-form-field>
  </ib-mat-form-field-wrap>

  <ib-mat-form-field-wrap
    *ngIf="formS.accountType === USER_TYPE.COMPANY"
    [formCtrlName]="SIGN_UP_FIELDS.COMPANY_VAT"
    [formCtrl]="form.get(SIGN_UP_FIELDS.COMPANY_VAT)"
    [showClearBtn]="true"
    [tooltipText]="
      'Companies should enter their VAT number that is 8 characters where the second will sometimes be a letter and the last is always a letter, the rest are integer'
    "
  >
    <mat-form-field>
      <mat-label>Company VAT</mat-label>
      <input
        matInput
        #vatInput
        formControlName="{{ SIGN_UP_FIELDS.COMPANY_VAT }}"
        type="text"
        required
      />
    </mat-form-field>
  </ib-mat-form-field-wrap>

  <hr class="my-36px" />

  <div class="relative">
    <div *ngIf="!docs?.length" class="text-center mx-16px">
      {{ 'page.sign-up.steps.3.descr' | transloco }}
    </div>

    <div *ngIf="docs?.length" class="mt-24px mb-24px">
      <ib-selected-docs
        [docsMainFormGroup]="formS.docsMainFormGroup"
        [setFocusToAdded]="true"
        [docs]="docs"
        [docsFormGroupsMap]="formS.docsFormGroupsMap"
        (removeDoc)="removeDoc($event)"
      >
      </ib-selected-docs>
    </div>

    <div
      *ngIf="docListAbstrFormCtrl?.invalid && docListAbstrFormCtrl?.touched"
      class="flex justify-center items-center my-16px"
    >
      <ib-input-error
        class="text-11px"
        [formCtrl]="docListAbstrFormCtrl"
      ></ib-input-error>
    </div>

    <div
      *ngIf="formS.docsMainFormGroup.invalid"
      class="mt-16px"
      [ngClass]="[
        showDoubleSelection
          ? 'grid grid-cols-2 gap-5'
          : 'flex justify-center items-center'
      ]"
    >
      <div class="relative">
        <ib-upload
          [addedDocs]="docs"
          class="w-full"
          [disabled]="formS.docsMainFormGroup.valid"
          btnClass="ib-btn ib-btn-secondary px-16px! flex-col ib-btn-outline  w-full w-max-160px h-80px!"
          (selected)="addDocs($event)"
        >
        </ib-upload>

        <ib-tooltip
          class="block mt-8px"
          text="{{
            ('comp.add-file.tooltip' | transloco) +
              (!showDoubleSelection
                ? ('comp.make-photo.tooltip-or' | transloco)
                : '')
          }}"
        ></ib-tooltip>
      </div>

      <div *ngIf="showDoubleSelection" class="relative">
        <ib-webcam
          class="block w-full"
          [disabled]="formS.docsMainFormGroup.valid"
          btnClass="ib-btn-secondary px-16px! flex-col ib-btn-outline w-full w-max-160px h-80px!"
          (confirmed)="addDocs($event)"
        >
        </ib-webcam>

        <ib-tooltip
          class="block mt-8px"
          text="{{ 'comp.make-photo.tooltip' | transloco }}"
        >
        </ib-tooltip>
      </div>
    </div>

    <ib-spinner
      *ngIf="!isDevicesInited"
      class="my-30px"
      [diameter]="30"
      [fluid]="true"
      class="bg-white z-999"
    ></ib-spinner>
  </div>

  <div class="mt-36px">
    {{ 'page.sign-up.steps.3.doc-type-title' | transloco }}:
  </div>

  <mat-radio-group
    formControlName="{{ SIGN_UP_FIELDS.DOC_TYPE }}"
    required
    class="flex flex-col mt-8px"
  >
    <ng-container *ngFor="let doc of docTypes">
      <mat-radio-button [value]="doc.type" class="block cursor-pointer">
        {{ doc.translateKey | transloco }}
      </mat-radio-button>
    </ng-container>
  </mat-radio-group>
</form>
